<template>
  <div
    class="white-card border border"
    :class="{ force_dark: isForceDark, 'theme--dark': isForceDark, 'px-md-4 py-3 px-3': hasPadding, 'text-center': isCentered }"
  >
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "WhiteCard",
  components: {},
  props: {
    rounded: {
      type: String,
      default: "lg",
    },
    isForceDark: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: true,
    },
    hasPadding: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({ mode: (state) => state.customize["dark-mode"] }),
    customClass() {
      const res = [];

      this.rounded ? res.push("rounded-" + this.rounded) : res.push("rounded");
      if (this.isForceDark) res.push("force_dark");
      if (this.isForceDark) res.push("theme--dark");
      if (this.hasPadding) res.push("px-md-4 py-3 px-3");
      if (this.isCentered) res.push("text-center");
      return res;
    },
  },
  data: () => ({
    isShowingUpgrade: false,
  }),
};
</script>
